﻿import { Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import classes from "./ordersAction.module.scss";

import { getToday, hasPermission } from "@/services/Utils";

import ButtonFilter from "@/components/Filter/ButtonFilter";

import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";
import { useOrderPaginate } from "@/hooks/purchases/orders";

const OrdersAction = ({ showFilter, setShowFilter, filters, setIntegrationSelect }) => {
	const { data } = useOrderPaginate(filters);
	const { permissions, integrations } = data ? data : {};

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { filter } = useSelector((state) => state.auth);

	const exportExcel = () => {
		const filename = `${location.pathname.replace("/", "")}  ${getToday()}.xlsx`;

		const params = {
			...filters,
			...filter,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: params,
					show: true,
					url: "/client/excel/orden_compra",
					name: filename,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} style={{ justifyContent: "right", display: "flex" }}>
				{integrations &&
					integrations.length > 0 &&
					integrations.map((integration, index) => {
						if (Number(integration.id) === 4) {
							return null;
						}

						return (
							<div
								key={index}
								className={`${classes.optionButton}`}
								onClick={() => {
									setIntegrationSelect({
										show: true,
										name: integration.name,
										integration: integration.slug,
									});
								}}
							>
								<span className={classes.spanIntegration}>Sincronizar</span>
								<img className={`${classes.imgIntegration} ${classes[integration.slug]}`} src={integration.logo} alt={integration.name} />
							</div>
						);
					})}

				{hasPermission("create", permissions) && (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							navigate(`${location.pathname}/ingresar`);
						}}
					>
						<span>Cargar</span>
					</div>
				)}

				<div className={`${classes.optionButton} ${classes.exportInventory}`} onClick={() => exportExcel()}>
					<span>Excel</span>
				</div>
			</Col>
		</Row>
	);
};

export default OrdersAction;
